import CloseIcon from '@mui/icons-material/Close';
import type { Breakpoint } from '@mui/material';
import { Box, Dialog, IconButton, Typography } from '@mui/material';

import clientUtils from '@/utils/clientUtils';

export interface BaseModalProps {
  open: boolean;
  title?: string;
  subTitle?: string;
  onClose: () => void;
  children?: React.ReactNode;
  width?: Breakpoint;
  hideCloseIcon?: boolean;
  fullscreen?: boolean;
  disableBackdropClose?: boolean;
  cssClassName?: string;
  id?: string;
  hideHeaderDivider?: boolean;
}

export const VNBaseModal = ({
  open,
  title,
  subTitle,
  onClose,
  children,
  width = 'sm',
  hideCloseIcon = false,
  fullscreen = false,
  disableBackdropClose = false,
  cssClassName = '',
  id = null,
  hideHeaderDivider = false,
}: BaseModalProps) => {
  // console.log('width', { width });

  const onTitleClick = () => {
    if (id) {
      clientUtils.copyToClipboard(id);
    }
  };
  return (
    <Dialog
      open={open}
      onClose={disableBackdropClose ? undefined : onClose}
      maxWidth={width}
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 2,
          overflow: 'hidden',
          p: 0,
        },
      }}
      fullScreen={fullscreen}
      className={`vn-base-modal ${cssClassName}`}
    >
      {/* HEADER */}
      <Box sx={{ px: '16px', pt: '8px' }}>
        <Box
          sx={{
            borderBottom: hideHeaderDivider ? 'none' : '1px solid #E6E8EC',
            minHeight: 44,
            // paddingBottom: '24px',
          }}
        >
          {/* Title + Close */}
          <Box
            sx={{
              // height: '44px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
            }}
          >
            <Typography sx={{ fontSize: '24px !important', cursor: id ? 'pointer' : 'none' }} onClick={onTitleClick}>
              {title}
            </Typography>

            {!hideCloseIcon && (
              <IconButton size="small" onClick={onClose}>
                <CloseIcon />
              </IconButton>
            )}
          </Box>

          {/* Subtitle */}
          {subTitle && (
            <Box
              sx={{
                // height: '24px',
                display: 'flex',
                alignItems: 'center',
              }}
            >
              <Typography sx={{ fontSize: '12px !important', color: '#797979' }}>{subTitle}</Typography>
            </Box>
          )}
        </Box>
      </Box>

      {/* BODY + FOOTER (slots) */}
      {children}
    </Dialog>
  );
};
